import AppHeader from "../../../components/header";
import { Stack, Typography } from "@mui/material";
import AppLoader from "../../../components/loader";
import GlobalButton from "../../../components/button";
import AddIcon from "@mui/icons-material/Add";
import DynamicTable from "../../../components/dynamicTable";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteServiceAgrement,
  getAllServiceAgrement,
} from "../../../services/AgrementApi";
import { AppContext } from "../../../lib/Context";
import { deleteAlert } from "../../../components/alerts";
import {
  setCurrentPage,
  setPageLimit,
  setTotalCount,
  setTotalPages,
} from "../../../lib/redux/slices/agreementPaginationSlice";

const ServiceAgrementPage = () => {
  const { userData } = useContext(AppContext);
  const isAdmin = userData?._id === process.env.REACT_APP_ADMIN_ID;
  const [allServiceAgrement, setAllServiceAgrement] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const paginatedData = useSelector((state) => state.agreementPaginatedReducer);

  const tableHeader = [
    "Created At",
    "Signed On",
    "Business Name",
    ...(isAdmin ? ["Created By"] : []),
    "Status",
    "Actions",
  ];
  const displayRows = [
    "lead_created_date",
    "agrement_signed_on",
    "businessName",
    ...(isAdmin ? ["agrement_created_by"] : []),
    "agrement_status",
    "actions",
  ];

  const fetchAllServiceAgrement = async (pageToLoad, limit) => {
    setIsLoading(true);
    try {
      const response = await getAllServiceAgrement(userData, {
        page: pageToLoad,
        limit,
      });
      if (response?.data.status === "success") {
        setAllServiceAgrement(response?.data.data);
        const pagination = response?.data.pagination;
        if (pagination) {
          dispatch(setPageLimit(pagination.limit));
          dispatch(setTotalPages(pagination.totalPages));
          dispatch(setTotalCount(pagination.total));
          dispatch(setCurrentPage(pagination.page));
        }
      }
    } catch (error) {
      console.error(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllServiceAgrement(paginatedData.page, paginatedData.limit);
  }, [paginatedData.page, paginatedData.limit]);

  const handleRowsPerPageChange = (event) => {
    const limit = parseInt(event.target.value, 10);
    dispatch(setPageLimit(limit));
    dispatch(setCurrentPage(1));
  };

  const handlePageChange = (event, newPage) => {
    const page = newPage + 1;
    dispatch(setCurrentPage(page));
  };

  const handleAddServiceAgrement = () => {
    navigate(`/service-agrement/add`);
  };

  const handleViewServiceAgrement = (row) => {
    navigate(`/service-agrement/view/${row._id}`);
  };

  const handleEditServiceAgrement = (row) => {
    navigate(`/service-agrement/edit/${row._id}`);
  };

  const handleDeleteAgreement = async (row) => {
    deleteAlert(true, row?._id, deleteServiceAgrement, () =>
      fetchAllServiceAgrement(paginatedData.page, paginatedData.limit),
    );
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        gap={2}
      >
        <Stack mb={3}>
          <Typography
            variant="primaryText"
            component={"h1"}
            fontSize={{ xs: "1.5rem", md: "2.125rem" }}
          >
            List Of All Service Agreements
          </Typography>
          <Typography variant="secondaryText" component={"p"}>
            You can add and view service agreements
          </Typography>
        </Stack>
        {userData?.designation === "Sales Agent" && (
          <GlobalButton
            variant="custom_gradient"
            title="Add Service Agreement"
            startIcon={<AddIcon />}
            style={{
              width: { xs: "100%", sm: "auto" },
              borderRadius: "100px",
            }}
            handleClickBtn={handleAddServiceAgrement}
          />
        )}
      </Stack>

      <DynamicTable
        tableData={allServiceAgrement || []}
        displayRows={displayRows}
        tableHeader={tableHeader}
        showDetail={true}
        showEdit={true}
        handleEdit={handleEditServiceAgrement}
        showDeleteIcon={isAdmin ? true : false}
        handleNavigateToDetail={handleViewServiceAgrement}
        handleDelete={handleDeleteAgreement}
        isPaginated={true}
        paginatedData={paginatedData}
        onRowsPerPageChange={handleRowsPerPageChange}
        onPageChange={handlePageChange}
      />

      {allServiceAgrement?.length === 0 && isLoading === false && (
        <Typography variant="h5" fontWeight={600} textAlign={"center"}>
          No Data Found !
        </Typography>
      )}
    </AppHeader>
  );
};

export default ServiceAgrementPage;
